import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipolanding'
})
export class TipolandingPipe implements PipeTransform {

  transform(value: any): any {



    const resultPost2 = [];
    for (const lot of value) {
      let valordescripcion: string = lot.descripcionlote;
      valordescripcion = valordescripcion.toUpperCase();



      if (valordescripcion.indexOf("SMX") != -1) {
        resultPost2.push(lot);
      }
    }





    return resultPost2;




  }

}
